export default __webpack_public_path__ + "images/3deec3878e490a4f15151f6dd6e9a484.png";